import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PhotoContext } from '../../context/PhotoProvider';

import '../../App.scss';

import styles from './styles.module.scss';
import { APP_ROUTES } from '../../constants/appRoutes';
import { useNavigate } from 'react-router-dom';
import NavButton from '../../components/NavButton';

const stylesMap = {
  black: 'Original',
  'pop-art': 'Pop Art',
  sepia: 'Sepia',
};

const mozaic = {
  title: 'thisIsHowYourFutureDiamondWillLook',
  uploadPhotoLink: APP_ROUTES.UPLOAD_PHOTO,
  stylesMap,
};

const PhotoStyles = () => {
  const photoFilterFRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateBack = () => {
    navigate(mozaic.uploadPhotoLink);
  };

  const { editedPhotosArr } = useContext(PhotoContext);

  // TODO: need update this logic on backend
  const reducedKeys = Object.keys(editedPhotosArr).splice(0, 3);

  return (
    <div className={styles.photoStyleContainer} ref={photoFilterFRef}>
      <h1>
        {t('Example of your picture created with the Diamond Painting kit')}
      </h1>
      <div className={styles.photosContainer}>
        {reducedKeys.map((key) => (
          <div key={editedPhotosArr[key]} className={styles.surfaceWrapper}>
            <img src={editedPhotosArr[key]} />
            <h4>{mozaic.stylesMap[key as keyof typeof stylesMap]}</h4>
          </div>
        ))}
      </div>
      <NavButton text="Back" type="back" onClick={navigateBack} />
    </div>
  );
};

export default PhotoStyles;
